import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-category',
  templateUrl: './addusers.component.html',
  styleUrls: ['./addusers.component.css']
})
export class AddUsersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
